import React from 'react';
import Image from 'next/image';
import { trackSegmentTrackEvent } from '~/app/lib/segment-analytics';
import { useAnalyticsPageView } from '@nerdwallet/seo-analytics';
import { Article } from './types';
import styles from './article-card.module.scss';
import SegmentImpression from '../../segment-impression';

interface IArticleCardProps {
  article?: Article;
}

const ArticleCard = ({ article }: IArticleCardProps): JSX.Element | null => {
  const { pageViewId } = useAnalyticsPageView();

  const handleAnalytics = () => {
    trackSegmentTrackEvent('Element Interaction', pageViewId, {
      entity_name: `breaking_news_id_${article?.id}`,
      location: 'tariff-hub-lp',
      sublocation: 'breaking-news',
      action: 'select',
    });
  };

  if (!article) return null;
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const formattedDate = new Date(article.date).toLocaleDateString(
    'en-US',
    options
  );

  return (
    <SegmentImpression
      eventName="Element Impression"
      eventProps={{
        entity_name: `breaking_news_id_${article?.id}`,
        location: 'tariff-hub-lp',
        sublocation: 'breaking-news',
      }}
    >
      <div className={styles.carouselCard}>
        {article.featuredMedia?.sourceUrl && (
          <Image
            className={styles.articleImage}
            src={article.featuredMedia.sourceUrl}
            alt="Article Image"
            width={262}
            height={180}
          />
        )}
        <div className={styles.carouselContent}>
          <a
            href={article?.link}
            onClick={() => handleAnalytics()}
            className={styles.articleLinks}
          >
            <h3 className={styles.carouselTitle}>{article.title}</h3>
          </a>
          <div className={styles.articleInfo}>
            <div className={styles.carouselAuthorInfo}>
              <Image
                className={styles.authorImage}
                src={article.authors?.[0]?.avatarUrls?.[0].url}
                alt="author image"
                width={160}
                height={160}
              />
              <a
                href={article.authors?.[0]?.link}
                className={styles.articleLinks}
              >
                <p className={styles.authorName}>
                  by {article.authors?.[0].name}
                </p>
              </a>
            </div>
            <div className={styles.carouselArticleMeta}>
              <span className={styles.carouselArticleMetaText}>
                {formattedDate}
              </span>
              {article.timeToRead && article.timeToRead.minutes >= 1 ? (
                <span
                  className={styles.carouselArticleMetaText}
                >{`${article.timeToRead.minutes} min read`}</span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </SegmentImpression>
  );
};

export default ArticleCard;
